import { Fragment } from 'react';
import { useChains, useConnection } from 'wagmi';

export default function ModalSwitchNetworkContent({
  network,
}: {
  network: { id: number };
}) {
  const { connector } = useConnection();
  const chains = useChains();
  const name =
    chains.find((c) => c.id === network.id)?.name ?? `chain ${network.id}`;
  const wallet = connector?.name ?? '';
  return (
    <div className="bg-background-secondary p-7.5 max-md:w-full">
      <div className="text-body-md font-semibold text-gray">Switch network</div>
      <div className="mt-xl text-h1 font-bold text-gray-text">
        Switch to the {name} network
        <br />
        to continue
      </div>
      <div className="mt-7.5 grid auto-rows-min grid-cols-[20px_auto] gap-y-xl">
        {[
          `This transaction runs on ${name}.`,
          'Switch networks to continue.',
          `Approve the network switch in ${wallet} or switch it manually.`,
        ].map((text, idx) => (
          <Fragment key={text}>
            <div className="text-body-lg font-bold text-gray-text">
              {idx + 1}.
            </div>
            <div className="text-body-lg text-gray-text">{text}</div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
